import HeartIcon from '@assets/icons/heart.svg'

export const Loading = ({ top = 0 }: { top?: number }) => (
  <div className="absolute left-0 z-50 flex h-full w-full animate-fade-in items-center justify-center bg-white/70" style={{ top }}>
    <img src={HeartIcon} className="h-20 animate-pulse" />
  </div>
)
